import { render, staticRenderFns } from "./planData.vue?vue&type=template&id=9b680de4&scoped=true&"
import script from "./planData.vue?vue&type=script&lang=js&"
export * from "./planData.vue?vue&type=script&lang=js&"
import style0 from "./planData.vue?vue&type=style&index=0&id=9b680de4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b680de4",
  null
  
)

export default component.exports